import { useEffect, useState } from "react";
import ModalVideo from "react-modal-video";
import { useDispatch, useSelector } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import images from "../../assets/images";
import RegisterFree from "../../components/RegisterFree";
import { getHowtousecontent } from "../../redux/homepage/saga";
import { HowtoUseContentDto } from "../../redux/homepage/type";
import { getLocalization } from "../../redux/localization";
const RentalInfo = () => {
  const t = useSelector(getLocalization);
  const [isOpen, setisOpen] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [data, setData] = useState<HowtoUseContentDto[]>([]);
  useEffect(() => {
    dispatch(
      getHowtousecontent({
        payload: {
          onSuccess: (message, payload) => {
            setData(payload);
          },
          onError: () => {},
        },
      })
    );
  }, [dispatch]);
  return (
    <>
      <section className="rentalInfoSection py-5">
        <div className="col-12 videoButtonComponent">
          <div
            onClick={() => {
              setisOpen(!isOpen);
            }}
          >
            <img src={images.videoBtn} alt="Video" />
          </div>
        </div>
        <ModalVideo
          videoId="irxXOau4KXM"
          channel="youtube"
          isOpen={isOpen}
          onClose={() => {
            setisOpen(!isOpen);
          }}
        />
        <Container>
          <Row>
            <Col md={7} className="rentalHeader">
              <h2> {t.getString("Easy To Use Rental Software")}</h2>   
              <h3>
                {t.getString(
                  "Few features to grow up your rental business"
                )}
              </h3>
            </Col>
            <Col md={5} className="rentalDot">
              <img src={images.dot} alt={"Rentificial dot"} width={"100%"} />
            </Col>
          </Row>
          <Row className="mt-5 justify-content-center">
            {data.map((x, i) => (
              <Col lg={4} key={i} style={{ maxWidth: "600px" }}>
                <div className="rentalInfoItem">
                  <div className="text-center iconItem">
                    {/* <i
                      className={x.Icon + " font-size-44 text-pr iconMaxHeight"}
                    /> */}
                  </div>
                  <h4>{x.Title}</h4>
                  <p dangerouslySetInnerHTML={{ __html: x.Description }} />
                </div>
              </Col>
            ))}
          </Row>
          <RegisterFree />
        </Container>
      </section>
    </>
  );
};

export default RentalInfo;
